import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import {AuthGuard, GuestGuard} from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';
import LoginSchoolPage from "../../pages/auth/jwt/loginSchool";

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));
const GuestRegisterPage = lazy(() => import('src/pages/auth/jwt/guestRegister'));
const JwtRegisterPage = lazy(() => import('src/pages/auth/jwt/register'));
const JwtVerifyPage = lazy(() => import('src/pages/auth/jwt/verify'));
const VerifyPendingPage = lazy(() => import('src/pages/auth/verify-pending'));
const VerifySuccessPage = lazy(() => import('src/pages/auth/verify-success'));
const ForgotPasswordPage = lazy(() => import('src/pages/auth/forgot-password'));
const ResetPasswordPage = lazy(() => import('src/pages/auth/reset-password'));

// ----------------------------------------------------------------------

const authJwt = {
  path: 'jwt',
  element: (

      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
  ),
  children: [
    {
      path: 'login',
      element: (
        <GuestGuard>
        <AuthClassicLayout>
          <JwtLoginPage />
        </AuthClassicLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'login/school',
      element: (
        <GuestGuard>
          <AuthClassicLayout>
            <LoginSchoolPage />
          </AuthClassicLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'guest-register',
      element: (
        <GuestGuard>
          <GuestRegisterPage />
        </GuestGuard>
      ),
    },
    {
      path: 'register',
      element: (
        <AuthGuard>
        <AuthClassicLayout title="Учи математика бързо и лесно">
          <JwtRegisterPage />
        </AuthClassicLayout>
        </AuthGuard>
      ),
    },
    {
      path: 'verify',
      element: (
        <AuthClassicLayout title="Потвърждаване на имейл">
          <JwtVerifyPage />
        </AuthClassicLayout>
      ),
    },
    {
      path: 'verify-pending',
      element: (
        <AuthClassicLayout title="Провери своя имейл">
          <VerifyPendingPage />
        </AuthClassicLayout>
      ),
    },
    {
      path: 'verify-success',
      element: (
        <AuthClassicLayout title="Успешна регистрация">
          <VerifySuccessPage />
        </AuthClassicLayout>
      ),
    },
    {
      path: 'forgot-password',
      element: (
        <AuthClassicLayout title="Забравена парола">
          <ForgotPasswordPage />
        </AuthClassicLayout>
      ),
    },
    {
      path: 'reset-password',
      element: (
        <AuthClassicLayout title="Възстановяване на парола">
          <ResetPasswordPage />
        </AuthClassicLayout>
      ),
    }
  ],
};

export const authRoutes = [
  {
    path: 'auth',
    children: [authJwt],
  },
];
